module.exports = __webpack_public_path__ + "static/media/animal_01.1a822f7d.png";